import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DEFAULT_REDIRECT_PATH,
  LOCAL_STORE_TOKEN,
} from '../../Share/constants';
import { NotFound } from '../../Share/components';

const propTypes = {
  children: PropTypes.node.isRequired,
  layout: PropTypes.elementType.isRequired,
  displayKPIReports: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
};

function PrivateRoute({
  children,
  displayKPIReports = false,
  layout: Layout,
  path = '',
}) {
  const location = useLocation();

  if (path && !window.localStorage.getItem(LOCAL_STORE_TOKEN)) {
    window.localStorage.setItem(DEFAULT_REDIRECT_PATH, path);
  }

  if (!window.localStorage.getItem(LOCAL_STORE_TOKEN)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (path?.includes('/reports') && !displayKPIReports) {
    return <NotFound />;
  }

  return <Layout>{children}</Layout>;
}

PrivateRoute.propTypes = propTypes;

const mapStateToProps = state => ({
  displayKPIReports: state.authentication.displayKPIReports,
});

export default connect(mapStateToProps, null)(PrivateRoute);
